export { CloudUpload as default } from './CloudUpload';
